import apiClient from './api';
import type { AgentQualification, Qualification } from '@/types';

export const qualificationService = {
  async list(): Promise<Qualification[]> {
    const response = await apiClient.get<Qualification[]>('/qualifications');
    return response.data;
  },

  /**
   * Remplace l'integralite des qualifications d'un agent.
   */
  async updateAgentQualifications(
    agentId: number,
    qualifications: Array<{ qualificationId: number; valideJusquau?: string }>
  ): Promise<AgentQualification[]> {
    const response = await apiClient.put<AgentQualification[]>(`/agents/${agentId}/qualifications`, {
      qualifications,
    });
    return response.data;
  },
};

export default qualificationService;
